import type { LiveUiTitle } from '@/types';
import { OVERLAY_TRANSPARENCY, Wordmark } from '../components/overlay';

// GET /:eventSlug/live/ui/title — the wordmark card on its own, over the title card
// scene. Only Bogotá ships it.
export default function Title({ overlay }: LiveUiTitle) {
  return (
    <>
      <style>{OVERLAY_TRANSPARENCY}</style>
      <div className="fixed inset-0 overflow-hidden">
        <Wordmark overlay={overlay} />
      </div>
    </>
  );
}
